module.exports = __webpack_public_path__ + "static/media/morrowind.47fee815.mp3";